/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  Platform,
  Dimensions,
  KeyboardAvoidingView,
  useWindowDimensions,
  TouchableOpacity,
  RefreshControl,
} from "react-native";
import { useSelector, useDispatch } from "react-redux";
import { useSelectedLocation } from "../hooks";
// Import the LeadershipWalkMetrics component
import LeadershipWalkMetrics from "./leadershipwalk/components/LeadershipWalkMetrics";
import LeadershipWalkWelcome from "./leadershipwalk/components/LeadershipWalkWelcome";
import WeeklyZonesCompleted from "./leadershipwalk/components/WeeklyZonesCompleted";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { RootState } from "../store";
import { createApiClient, apiClient, getLocalTimestamp } from "../api/apiClient";
import { formatDate } from "../utils/dateFormatter";
import { getYearOptions } from "../utils/filterOptions";
import {
  fetchZones,
  fetchLeadershipWalks,
  LeadershipWalkModal,
} from "./leadershipwalk";
import {
  setError as setLeadershipWalkError,
  setSelectedZone,
  setSelectedFrequency,
  setSelectedLeadershipWalk,
  setQuestions,
  setWalkId,
  setSuccessMessage,
} from "../store/slices/leaderShipWalkSlice";
import {
  setQuestions as setRedirectQuestions,
  setSelectedQuestions,
  setMiscObservationImage,
  setMiscellaneousObservations,
  setManagerSignature,
  toggleOption,
  setWalkState,
  setSelectedRecord,
  addImage,
  resetSelectedOptions,
  resetLeadershipWalkRedirect,
  setLoading as setRedirectLoading,
} from "../store/slices/leadershipWalkRedirectSlice";
import LHOverlay from "../components/LHOverlay";
import { leadershipWalkTableColumns } from "../data/leadershipWalkData";
import LhButton from "../components/LhButton";
import CrossPlatformDropdown from "../components/CrossPlatformDropdown";
import { LeadershipWalkRecord } from "./leadershipwalk/utils/fetchLeadershipWalkData";
import LeadershipWalkDetails from "./leadershipwalk/components/LeadershipWalkDetails";
import LeadershipWalkErrorModal from "./leadershipwalk/components/LeadershipWalkErrorModal";
import { 
  handleLeadershipWalkErrorWithFriendlyMessage, 
  LEADERSHIP_WALK_API_NAMES 
} from "../store/utils/leadershipWalkErrorHandler";
import { formatUserName } from "../utils/emailTouserName";
import { isIOSMobile, isMobileDevice } from "./sparcwalk/utils/deviceDetection";
import MobileFilterOverlay from "../components/MobileFilterOverlay";
import LeadershipWalkBegin from "./leadershipwalk/components/LeadershipWalkBegin";
import { DropdownItem } from "../types/observation";
import { useTheme } from "../theme";

interface Zone {
  ZONE_ID: number;
  ZONE: string;
}

const VIEW_TYPES = {
  WELCOME: "welcome" as const,
  DETAILS: "details" as const,
}

interface LeadershipWalkFilterState {
  zone: DropdownItem | null;
  frequency: DropdownItem | null;
  createdBy: string;
  modifiedBy: string;
  action: string;
  period: string;
  week: string;
  year: string;
}

interface EmployeeData {
  zone: string;
  frequency: string;
  created: string;
  createdBy: string;
  modified: string;
  modifiedBy: string;
  action: string;
  observation: string;
  miscellaneousObservations: string;
}

interface LeaderShipWalkProps {
  onBackPress: () => void;
  onLeadershipWalkRedirectClick: () => void;
  onSiteEvaluationClick?: () => void;
}

const LeaderShipWalkScreen: React.FC<LeaderShipWalkProps> = ({
  onBackPress,
  onLeadershipWalkRedirectClick,
  onSiteEvaluationClick,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === "dark";
  const { width } = useWindowDimensions();
  const isMobile = width < 768;
  const height = Dimensions.get("window").height;
  const dispatch = useDispatch();
  const [isFilterOverlayVisible, setFilterOverlayVisible] = useState(false);
  const [isMobileFilterOverlayVisible, setMobileFilterOverlayVisible] =
    useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showWeekOneModal, setShowWeekOneModal] = useState(false);

  // Add separate state for begin overlay filters
  const [beginOverlayFilters, setBeginOverlayFilters] = useState<{
    zone: Zone[];
    frequency: DropdownItem | null;
  }>({
    zone: [],
    frequency: null,
  });

  // Separate loading states for different operations
  const [leadershipWalksLoading, setLeadershipWalksLoading] = useState(false); // For main table data
  const [detailsLoading, setDetailsLoading] = useState(false); // For row click and details view
  const [loading, setLoading] = useState(false); // Legacy loading state - keeping for backward compatibility

  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] =
    useState<LeadershipWalkRecord | null>(null);
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [currentView, setCurrentView] = useState("LIST");
  const [filters, setFilters] = useState<LeadershipWalkFilterState>({
    zone: null,
    frequency: null,
    createdBy: "",
    modifiedBy: "",
    action: "",
    period: "",
    week: "",
    year: "",
  });
  const [appliedFilters, setAppliedFilters] =
    useState<LeadershipWalkFilterState>({
      zone: null,
      frequency: null,
      createdBy: "",
      modifiedBy: "",
      action: "",
      period: "",
      week: "",
      year: "",
    });
  // Remove filteredEmployees state; always use transformedEmployees for tableData
  const [zonesCompleted, setZonesCompleted] = useState<{
    totalZones: number;
    completedZoneIds: number[];
  }>({ totalZones: 0, completedZoneIds: [] });
  const [refreshing, setRefreshing] = useState(false);

  // Get data from Redux store
  const { periodWeek } = useSelector((state: any) => state.appData);
  console.log("Period/Week data from Redux:", periodWeek);
  const currentWeek = Number(periodWeek?.data?.week) || 0;
  const isWeekOne = currentWeek === 1;
  const selectedLocation = useSelectedLocation();
  const { zones, walkId, questions, leadershipWalks } = useSelector(
    (state: RootState) => state.leadershipWalk
  );
  const successMessage = useSelector(
    (state: RootState) => state.leadershipWalk.successMessage
  );
  console.log("leadershipWalks:", leadershipWalks);
  const frequencyOptions = [
    { id: "1", displayText: "Weekly" },
    { id: "2", displayText: "Quarterly" },
  ];

  // Function to handle filter changes in the Begin overlay
  const handleBeginOverlayFilterChange = (
    filterType: "zone" | "frequency",
    value: DropdownItem | DropdownItem[] | null
  ) => {
    if (filterType === "zone" && Array.isArray(value)) {
      const transformedZones = value.map((item) => ({
        ZONE_ID: Number(item.id),
        ZONE: item.displayText,
      }));
      setBeginOverlayFilters((prev) => ({
        ...prev,
        [filterType]: transformedZones,
      }));
      // Update Redux store only for Begin overlay
      dispatch(setSelectedZone(transformedZones));
    } else if (filterType === "frequency" && value && !Array.isArray(value)) {
      setBeginOverlayFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
      // Update Redux store only for Begin overlay
      dispatch(setSelectedFrequency(value.displayText));
    } else if (value === null || (Array.isArray(value) && value.length === 0)) {
      setBeginOverlayFilters((prev) => ({
        ...prev,
        [filterType]: filterType === "zone" ? [] : null,
      }));
      // Update Redux store accordingly
      if (filterType === "zone") {
        dispatch(setSelectedZone([]));
      } else if (filterType === "frequency") {
        dispatch(setSelectedFrequency(""));
      }
    }
  };

  const handleBeginClick = () => {
    if (!selectedLocation) {
      dispatch(setLeadershipWalkError("No location selected"));
      return;
    }
    if (isWeekOne) {
      setShowWeekOneModal(true);
      return;
    }
    setFilterOverlayVisible(true);
  };

  const handleComplete = async (item: EmployeeData) => {
    try {
      console.log("Marking walk as completed:", item);
      // After successful completion, refresh the walks
      if (selectedLocation?.displayText) {
        await fetchLeadershipWalks({
          location: selectedLocation.displayText,
          dispatch,
        });
      }
    } catch (error) {
      console.error("Error completing walk:", error);
      setError(
        error instanceof Error ? error.message : "Failed to complete walk"
      );
    }
  };

  // Mobile filter handlers
  const handleMobileFilterPress = () => {
    setMobileFilterOverlayVisible(true);
  };

  const handleMobileFilterCancel = () => {
    setMobileFilterOverlayVisible(false);
  };

  // Mobile filter proceed handler
  const handleMobileFilterProceed = async (
    nextFilters: Partial<Record<string, any>> = {}
  ) => {
    console.log(
      "[MOBILE FILTER DEBUG] handleMobileFilterProceed called with:",
      nextFilters
    );

    // Normalize zone and frequency values
    const zoneValue = Object.prototype.hasOwnProperty.call(nextFilters, "zone")
      ? (nextFilters.zone as DropdownItem | null)
      : filters.zone;
    const frequencyValue = Object.prototype.hasOwnProperty.call(
      nextFilters,
      "frequency"
    )
      ? (nextFilters.frequency as DropdownItem | null)
      : filters.frequency;

    console.log("[MOBILE FILTER DEBUG] Frequency value:", frequencyValue);

    const normalizedZone =
      zoneValue && zoneValue.displayText === "All" ? null : zoneValue;
    const normalizedFrequency =
      frequencyValue && frequencyValue.displayText === "All"
        ? null
        : frequencyValue;

    const normalizedFilters: LeadershipWalkFilterState = {
      zone: normalizedZone ?? null,
      frequency: normalizedFrequency ?? null,
      createdBy: Object.prototype.hasOwnProperty.call(nextFilters, "createdBy")
        ? (nextFilters.createdBy as string) || ""
        : filters.createdBy,
      modifiedBy: Object.prototype.hasOwnProperty.call(
        nextFilters,
        "modifiedBy"
      )
        ? (nextFilters.modifiedBy as string) || ""
        : filters.modifiedBy,
      action: Object.prototype.hasOwnProperty.call(nextFilters, "action")
        ? (nextFilters.action as string) || ""
        : filters.action,
      period: Object.prototype.hasOwnProperty.call(nextFilters, "period")
        ? (nextFilters.period as string) || ""
        : filters.period,
      week: Object.prototype.hasOwnProperty.call(nextFilters, "week")
        ? (nextFilters.week as string) || ""
        : filters.week,
      year: Object.prototype.hasOwnProperty.call(nextFilters, "year")
        ? (nextFilters.year as string) || ""
        : filters.year,
    };

    // Update filters state
    setFilters(normalizedFilters);

    // Apply filters will be triggered by the auto-apply useEffect hook
    // when the filters state changes, so we don't need to call it directly here

    setMobileFilterOverlayVisible(false);
  };

  // ...existing code...

  const applyFilters = useCallback(async () => {
    try {
      setLeadershipWalksLoading(true); // Use specific loading state for table data
      setLoading(true); // Keep setting the legacy loading state for backward compatibility

      // Update the appliedFilters state with current filter values
      setAppliedFilters(filters);

      if (!selectedLocation?.displayText) {
        throw new Error("No location selected");
      }

      // Prepare API call parameters
      const location = selectedLocation.displayText;

      // Get zone IDs as a comma-separated string
      let zoneParam = "";
      if (filters.zone) {
        zoneParam = filters.zone.id.toString();
      }

      // Get all filter parameters
      const frequencyParam = filters.frequency
        ? filters.frequency.displayText
        : "";
      const createdByParam = filters.createdBy || "";
      const finalizedByParam = filters.modifiedBy || "";
      const actionParam = filters.action || "";
      const periodParam = filters.period || "";
      const weekParam = filters.week || "";
      const yearParam = filters.year || "";

      console.log("Applying filters with parameters:", {
        location,
        zone: zoneParam,
        frequency: frequencyParam,
        createdBy: createdByParam,
        finalizedBy: finalizedByParam,
        action: actionParam,
        period: periodParam,
        week: weekParam,
        year: yearParam,
      });

      // Fetch leadership walks with filters
      const response = await fetchLeadershipWalks({
        location,
        zone: zoneParam,
        frequency: frequencyParam,
        page: 1,
        pageSize: 200,
        dispatch,
        createdBy: createdByParam,
        finalizedBy: finalizedByParam,
        action: actionParam,
        period: periodParam,
        week: weekParam,
        year: yearParam,
      });

      console.log("API response after applying filters:", response);

      if (!(response && response.success)) {
        throw new Error(response?.error || "Failed to fetch data with filters");
      }
    } catch (err) {
      console.error("Error applying filters:", err);
      setError(err instanceof Error ? err.message : "Failed to apply filters");
    } finally {
      setLeadershipWalksLoading(false); // Clear specific loading state
      setLoading(false); // Clear legacy loading state
    }
  }, [filters, selectedLocation, dispatch]);

  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    const timeout = new Promise<void>((_, reject) =>
      setTimeout(() => reject(new Error('refresh_timeout')), 3000)
    );
    try {
      await Promise.race([applyFilters(), timeout]);
    } catch {
      // timeout or error — silently cancel
    } finally {
      setRefreshing(false);
    }
  }, [applyFilters]);

  // Function to reset filters and reload data without filters
  const resetFilters = useCallback(async () => {
    try {
      setLeadershipWalksLoading(true); // Use specific loading state for table data
      setLoading(true); // Keep setting the legacy loading state for backward compatibility

      // Reset all filter state to default values
      const defaultFilters = {
        zone: null,
        frequency: null,
        createdBy: "",
        modifiedBy: "",
        action: "",
        period: "",
        week: "",
        year: "",
      };

      setFilters(defaultFilters);
      setAppliedFilters(defaultFilters);

      if (!selectedLocation?.displayText) {
        throw new Error("No location selected");
      }

      // Fetch leadership walks without any filters
      const response = await fetchLeadershipWalks({
        location: selectedLocation.displayText,
        dispatch,
        page: 1,
        pageSize: 200,
      });

      console.log("Applied reset filters, fetched data with no filters");

      if (!(response && response.success)) {
        throw new Error(
          response?.error || "Failed to fetch data after resetting filters"
        );
      }
    } catch (err) {
      console.error("Error resetting filters:", err);
      setError(err instanceof Error ? err.message : "Failed to reset filters");
    } finally {
      setLeadershipWalksLoading(false); // Clear specific loading state
      setLoading(false); // Clear legacy loading state
    }
  }, [selectedLocation, dispatch]);

  // Function to reset selected leadership walk but preserve zone
  const resetSelections = useCallback(() => {
    dispatch(setSelectedLeadershipWalk(null));
    console.log("Reset selected leadership walk (preserving zone)");
  }, [dispatch]);

  // Function to reset both selected zone and leadership walk
  const resetSelectionsComplete = useCallback(() => {
    dispatch(setSelectedZone([]));
    dispatch(setSelectedLeadershipWalk(null));
    console.log("Reset both selected zone and leadership walk");
  }, [dispatch]);

  const handleProceed = () => {
    if (!beginOverlayFilters.zone.length || !beginOverlayFilters.frequency) {
      setShowValidation(true);
      return;
    }
    setShowValidation(false);
    dispatch(resetLeadershipWalkRedirect());
    // Reset only leadership walk but preserve the selected zone when beginning a new walk
    resetSelections();
    onLeadershipWalkRedirectClick();
  };

  const renderFilterOverlay = () => (
    <LeadershipWalkBegin
      isVisible={isFilterOverlayVisible}
      onClose={() => {
        setFilterOverlayVisible(false);
        setShowValidation(false);
      }}
      zones={zones}
      frequencyOptions={frequencyOptions}
      beginOverlayFilters={beginOverlayFilters}
      showValidation={showValidation}
      handleBeginOverlayFilterChange={handleBeginOverlayFilterChange}
      onProceed={handleProceed}
    />
  );

  // Get the current selected options from Redux
  const currentSelectedOptions = useSelector(
    (state: RootState) => state.leadershipWalkRedirect.selectedOptions || []
  );

  // Function to handle row click in data table
  const handleRowClick = async (
    rowData: LeadershipWalkRecord & {
      isLeadershipWalkNavigation?: boolean;
      columnKey?: string;
    }
  ) => {
    console.log("Selected leadership walk record:", rowData);
    console.log("Column key:", rowData.columnKey);
    console.log(
      "isLeadershipWalkNavigation:",
      rowData.isLeadershipWalkNavigation
    );

    // Set loading state immediately before any operations
    setDetailsLoading(true);

    // Convert to LeadershipWalk format and store in Redux
    const rowDataForRedux = {
      id: rowData.ID,
      walkId: rowData.Walk_Number,
      Title: rowData.Title,
      Notes: rowData.Notes,
      Location_Name: rowData.Location_Name,
      Location_Name_Loc_ID: rowData.Location_Name_Loc_ID,
      Walk_Type: rowData.Walk_Type,
      Zone: rowData.Zone,
      Frequency: rowData.Frequency,
      Created: rowData.Created,
      Period: rowData.Period,
      Week: rowData.Week,
      SPARC_Category_Selected: rowData.SPARC_Category_Selected,
      Modified: rowData.Modified,
      Created_By: rowData.Created_By,
      Modified_By: rowData.Modified_By,
      status: rowData.status,
      createdBy: rowData.Created_By,
      observation: rowData.Notes || "",
      miscellaneousObservations: "",
      created: rowData.Created,
      modified: rowData.Modified,
      modifiedBy: rowData.Modified_By || "",
    };

    dispatch(setSelectedLeadershipWalk(rowDataForRedux));

    // For zone clicks, navigate immediately to the redirect screen
    if (rowData.columnKey === "zone" || rowData.isLeadershipWalkNavigation) {
      // Set loading state in Redux before navigating
      dispatch(setRedirectLoading(true));

      // Navigate to redirect screen immediately, don't wait for data
      console.log("Navigating to leadership walk redirect screen");
      onLeadershipWalkRedirectClick();
    } else {
      // For other columns, show the overlay immediately
      setOverlayVisible(true);
    }

    // For both scenarios, we need to fetch the same data
    try {
      const api = createApiClient();

      // Extract zone IDs from the full zone strings
      // Handle both lowercase and uppercase property names from API responses
      const zoneStr = (rowData as any).zone || rowData.Zone || "";
      console.log("Zone string:", zoneStr);

      // Parse zone ID from the string
      // Note: zoneStr could be in different formats:
      // 1. Just IDs: "1,3"
      // 2. Full zone description "3 - Layer / Red Zone / Docks"
      // 3. Multiple descriptions "1 - Front Zone, 3 - Back Zone"

      // Extract the numeric IDs, handling all possible formats
      const zoneIds: string[] = [];

      if (zoneStr) {
        // Split by commas for possible multiple zones
        const zoneParts = zoneStr.split(",");

        zoneParts.forEach((part: string) => {
          // Try to extract number from the beginning of the string
          const match = part.trim().match(/^(\d+)/);
          if (match && match[1]) {
            zoneIds.push(match[1]);
          } else {
            // If no number found at beginning, just use the whole value as fallback
            zoneIds.push(part.trim());
          }
        });
      }

      // Create the transformed zones for UI display with full names
      const transformedZones = zoneIds.map((id: string) => {
        const foundZone = zones.find((z: any) => String(z.ZONE_ID) === id);
        return foundZone
          ? { ZONE_ID: foundZone.ZONE_ID, ZONE: foundZone.ZONE }
          : { ZONE_ID: Number(id) || 0, ZONE: id }; // Convert to number or use 0 as fallback
      });

      // For API calls, just use the numeric IDs
      const zoneId = zoneIds.join(",");
      console.log("Zone IDsss:", zoneId);
      console.log("Transformed zones:", transformedZones);
      // Update the selected zone in Redux
      dispatch(setSelectedZone(transformedZones));

      const frequency =
        rowData.Frequency || (rowData as any).frequency || "weekly";

      // new        -> org context only
      // in-progress -> org context + recordId
      // completed   -> skip org context
      const walkStatus = rowData.action?.toLowerCase();
      const isInProgressWalk = walkStatus === 'in progress';
      const isCompletedWalk = walkStatus === 'completed';
      const existingWalkId = isInProgressWalk ? (rowData.id || rowData.ID) : null;
      const recordIdParam = existingWalkId ? `&recordId=${existingWalkId}` : '';
      const requestConfig = isCompletedWalk ? { _skipOrgContextForQuestions: true } : undefined;

      console.log('[LeadershipWalk] Fetching questions - status:', walkStatus, 'recordId:', existingWalkId);

      // First fetch the questions
      const questionsEndpoint = `/leadership-walks/questions?walkType=Leadership Walk&frequency=${frequency}&zoneIds=${zoneId}${recordIdParam}`;
      console.log("Fetching questions from:", questionsEndpoint);
      const questionsResponse = await apiClient(
        api,
        questionsEndpoint,
        "GET",
        undefined,
        requestConfig
      );

      if (!questionsResponse) {
        const userFacingError = "Unable to load questions. Please try again.";

        // Show modal overlay with friendly message and set local error
        try {
          handleLeadershipWalkErrorWithFriendlyMessage(
            LEADERSHIP_WALK_API_NAMES.FETCH_QUESTIONS,
            userFacingError,
            true,
            { zone: zoneId, frequency, walkId: rowData.id || rowData.ID }
          );
        } catch (e) {
          console.error('Failed to show leadership walk questions overlay:', e);
        }

        setError(userFacingError);
        // Close overlay (if it was opened) and stop further processing
        setOverlayVisible(false);
        setDetailsLoading(false);
        return;
      }

      // Then fetch the walk details
      const walkId = rowData.id || rowData.ID;
      if (!walkId) {
        throw new Error("Walk ID is missing");
      }

      const walkEndpoint = `/leadership-walks/${walkId}`;
      console.log("Fetching walk details from:", walkEndpoint);
      const walkResponse = await apiClient(api, walkEndpoint, "GET");

      if (!walkResponse) {
        throw new Error("Failed to fetch walk details");
      }
      console.log("Walk details response:", walkResponse);

      // Store both responses in Redux
      dispatch(setQuestions(questionsResponse)); // For leadershipWalkSlice
      dispatch(setRedirectQuestions(questionsResponse)); // For leadershipWalkRedirectSlice

      // Store walk response in Redux
      dispatch(setSelectedLeadershipWalk(walkResponse)); // For leadershipWalkSlice
      dispatch(setSelectedQuestions(walkResponse)); // For leadershipWalkRedirectSlice
      // Store the walk ID in both slices
      console.log("Setting walkId in Redux:", walkId);
      dispatch(setWalkId(parseInt(String(walkId), 10))); // For leadershipWalkSlice

      // Create a record object for leadershipWalkRedirect slice
      const recordObject = {
        id: String(walkId), // ID must be a string per LeadershipWalkRecord interface
        name: walkResponse.walkData?.location || zoneStr,
        createdBy:
          walkResponse.walkData?.createdBy || rowData.Created_By || "Unknown",
        created:
          walkResponse.walkData?.created ||
          rowData.Created ||
          getLocalTimestamp(),
      };
      console.log("Setting selectedRecord in Redux:", recordObject);
      dispatch(setSelectedRecord(recordObject)); // For leadershipWalkRedirectSlice

      // Set the walk state based on the status in the walk response
      if (walkResponse.walkData && walkResponse.walkData.status) {
        const statusValue = walkResponse.walkData.status || "";
        const status = statusValue.toLowerCase();
        if (status === "completed") {
          dispatch(setWalkState("completed"));
          console.log("Setting walk state to completed");
        } else if (status === "in progress") {
          dispatch(setWalkState("in_progress"));
          console.log("Setting walk state to in_progress");
        } else {
          dispatch(setWalkState("not_started"));
          console.log("Setting walk state to not_started (default)");
        }
      } else {
        // Default to not_started if no status is found
        dispatch(setWalkState("not_started"));
        console.log(
          "No status found in walk data, setting walk state to not_started"
        );
      }

      // Extract and store misc images from walkResponse if they exist
      if (walkResponse.walkData) {
        if (walkResponse.walkData.miscellImage) {
          dispatch(
            setMiscObservationImage({
              index: 0,
              image: {
                imageUrl: walkResponse.walkData.miscellImage,
                fileName: "",
                description: walkResponse.walkData.miscellImageDesc || "",
                index: 0,
              },
            })
          );
        }

        if (walkResponse.walkData.miscellImage2) {
          dispatch(
            setMiscObservationImage({
              index: 1,
              image: {
                imageUrl: walkResponse.walkData.miscellImage2,
                fileName: "",
                description: walkResponse.walkData.miscellImage2Desc || "",
                index: 1,
              },
            })
          );
        }

        // Store notes if they exist
        const notes = walkResponse.walkData.notes || walkResponse.Notes || "";
        if (notes) {
          dispatch(setMiscellaneousObservations(notes));
        }

        // Store manager signature if it exists
        if (walkResponse.walkData.managerSignature) {
          dispatch(
            setManagerSignature({
              fileName: walkResponse.walkData.managerSignature,
              imageUrl: walkResponse.walkData.managerSignature,
              isNewUpload: false,
            })
          );
        }
        console.log("leadershipimages11", walkResponse.leadershipImages);
        // Store leadershipImages if they exist (fix property name)
        const leadershipImages =
          walkResponse.leadershipWalkImages || walkResponse.leadershipImages;
        if (
          leadershipImages &&
          Array.isArray(leadershipImages) &&
          leadershipImages.length > 0
        ) {
          console.log("Found leadership images:", leadershipImages);

          // Process and store each image in Redux
          leadershipImages.forEach((image: any) => {
            if (image && image.ImageBase64) {
              const imageData = {
                imageId:
                  image.ImageId?.toString() || image.id?.toString() || "",
                imageUrl: image.ImageBase64,
                fileName: image.FileName || "",
                observationId: image.ObservationId?.toString() || "",
                description: image.Description || "",
              };

              dispatch(addImage(imageData));
            }
          });
        }

        // Store selected options based on toolsMapping
        if (
          walkResponse.toolsMapping &&
          Array.isArray(walkResponse.toolsMapping)
        ) {
          // Get the IDs of currently selected options
          const currentSelectedIds = currentSelectedOptions.map(
            (opt) => opt.id
          );
          console.log("Current selected options:", currentSelectedIds);

          // First, clear any existing selected options to prevent duplicates
          // ONLY if we're moving to LeadershipWalkRedirectScreen directly (zone click)
          if (
            rowData.columnKey === "zone" ||
            rowData.isLeadershipWalkNavigation
          ) {
            // Reset selected options completely before adding new ones
            dispatch(resetSelectedOptions());
          }

          // Map the tools to options format
          const selectedOptions = walkResponse.toolsMapping.map((tool: any) => {
            // Try to find question text from the questions
            let questionText = `ID: ${tool.toolId}`;

            // Check in all question sections
            ["Safety", "People", "Accuracy", "Reliability", "Costs"].forEach(
              (section) => {
                if (questionsResponse[section]) {
                  const question = questionsResponse[section].find(
                    (q: any) =>
                      q.ID?.toString() === tool.toolId?.toString() ||
                      q.id?.toString() === tool.toolId?.toString()
                  );

                  if (question) {
                    questionText =
                      question.Question ||
                      question.questionText ||
                      questionText;
                  }
                }
              }
            );

            return {
              id: tool.toolId?.toString() || "",
              label: questionText,
            };
          });

          // Add each option to Redux
          selectedOptions.forEach((option: { id: string; label: string }) => {
            if (
              !currentSelectedIds.includes(option.id) ||
              rowData.columnKey === "zone" ||
              rowData.isLeadershipWalkNavigation
            ) {
              dispatch(toggleOption(option));
            }
          });

          console.log(
            "Selected options after update:",
            selectedOptions.map((o: { id: string }) => o.id)
          );
        }
      }

      // We've already decided where to navigate earlier, but we need to update data
      if (rowData.columnKey === "zone" || rowData.isLeadershipWalkNavigation) {
        // We already navigated to the redirect screen, just update loading state
        console.log("Finishing data loading for redirect screen");
        dispatch(setRedirectLoading(false));
      } else {
        // For any other column, prepare the data for the modal
        console.log("Preparing data for modal overlay");
        // Include both the original row data and the API response
        // Use type assertion to avoid TypeScript errors
        setSelectedRowData({
          ...rowData,
          id: walkId,
          walkData: walkResponse.walkData || {},
          toolsMapping: walkResponse.toolsMapping || [],
          leadershipWalkImages: walkResponse.leadershipWalkImages || [],
          leadershipImages: walkResponse.leadershipImages || [],
        } as any);
        // The modal is already visible from the beginning of this function
      }
    } catch (error: any) {
      console.error("Error fetching leadership walk data:", error);
      
      // Use centralized error handler with modal overlay
      const zoneStr = (rowData as any).zone || rowData.Zone || "";
      const frequency = rowData.Frequency || (rowData as any).frequency || "weekly";
      
      handleLeadershipWalkErrorWithFriendlyMessage(
        LEADERSHIP_WALK_API_NAMES.FETCH_QUESTIONS,
        error,
        true, // Show modal overlay
        { 
          zone: zoneStr,
          frequency: frequency,
          walkId: rowData.id || rowData.ID
        }
      );
      
      setError(error.message || "Failed to fetch required data");

      if (rowData.columnKey === "zone" || rowData.isLeadershipWalkNavigation) {
        // Set the error in the redirect slice
        dispatch(setRedirectLoading(false));
        // No need to navigate, we already did that
      } else if (
        rowData.columnKey !== "zone" &&
        !rowData.isLeadershipWalkNavigation
      ) {
        // If there was an error and the overlay was opened, close it
        setOverlayVisible(false);
      }
    } finally {
      setDetailsLoading(false); // Clear details-specific loading state
    }
  };

  // Transform leadershipWalks data for the table with debug logging
  const transformedEmployees = useMemo(() => {
    console.log("Raw leadershipWalks data:", {
      isArray: Array.isArray(leadershipWalks),
      length: leadershipWalks?.length,
      data: leadershipWalks,
    });

    // First transform all data

    const allTransformed = leadershipWalks.map((walk) => {
      // ...existing zone, frequency, and date logic...
      const zoneId = walk.Zone || walk.zone || "";
      let zoneValue = "";
      if (zoneId && zones && Array.isArray(zones)) {
        const zoneIds: string[] = [];
        const zoneParts = zoneId.split(",");
        zoneParts.forEach((part) => {
          const match = part.trim().match(/^(\d+)/);
          if (match && match[1]) {
            zoneIds.push(match[1]);
          } else {
            zoneIds.push(part.trim());
          }
        });
        const zoneNames = zoneIds.map((id) => {
          const foundZone = zones.find((z) => String(z.ZONE_ID) === id);
          return foundZone ? foundZone.ZONE : id;
        });
        zoneValue = zoneNames.join(", ");
      } else {
        zoneValue = zoneId;
      }
      const frequencyValue = walk.Frequency || walk.frequency || "";
      const rawDate = walk.Created || walk.created || "";
      const dateValue = rawDate
        ? new Date(rawDate)
            .toLocaleString("en-GB", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })
            .replace(",", "")
        : "";
      const walkData = walk as any;
      const createdByEmail = walkData.Created_By || walkData.createdBy || "";
      const modifiedByEmail = walkData.Modified_By || walkData.modifiedBy || "";
      return {
        id: walkData.id || walkData.ID || null,
        zone: zoneValue,
        frequency: frequencyValue,
        created: walkData.Created || walkData.created || "",
        createdBy: createdByEmail ? formatUserName(createdByEmail) : "",
        createdByEmail,
        modified: walkData.Modified || walkData.modified || "",
        modifiedBy: modifiedByEmail ? formatUserName(modifiedByEmail) : "",
        modifiedByEmail,
        action: walkData.status || "Completed",
        observation: walkData.observation || "",
        miscellaneousObservations: walkData.miscellaneousObservations || "",
        period: walkData.Period || walkData.period || "",
        week: walkData.Week || walkData.week || "",
      };
    });

    // Apply filters if there are any
    console.log("[TRANSFORM DEBUG] Applied filters:", appliedFilters);
    const filteredData = allTransformed.filter((item) => {
      // Filter by zone if we have applied filters for zones
      if (appliedFilters.zone) {
        const zoneId = appliedFilters.zone.id.toString();
        const itemZoneText = item.zone;
        if (!itemZoneText) {
          return false;
        }

        // Check if the zone ID is in the item's zone string
        if (!itemZoneText.includes(zoneId)) {
          return false;
        }
      }

      // Filter by frequency
      if (
        appliedFilters.frequency &&
        appliedFilters.frequency.displayText &&
        appliedFilters.frequency.displayText !== "All"
      ) {
        const itemFrequency = item.frequency?.toLowerCase() || "";
        const filterFrequency =
          appliedFilters.frequency.displayText.toLowerCase();
        console.log(
          `[FREQUENCY FILTER DEBUG] Item frequency: "${itemFrequency}", Filter frequency: "${filterFrequency}"`
        );
        if (itemFrequency !== filterFrequency) {
          console.log(
            `[FREQUENCY FILTER DEBUG] Filtering out item with frequency "${itemFrequency}"`
          );
          return false;
        }
      }

      // Filter by Created By (compare email)
      if (appliedFilters.createdBy && appliedFilters.createdBy !== "") {
        if (item.createdByEmail !== appliedFilters.createdBy) {
          return false;
        }
      }

      // Filter by Finalized By (Modified By, compare email)
      if (appliedFilters.modifiedBy && appliedFilters.modifiedBy !== "") {
        if (item.modifiedByEmail !== appliedFilters.modifiedBy) {
          return false;
        }
      }

      // Filter by Action/Status
      if (appliedFilters.action && appliedFilters.action !== "") {
        if (item.action !== appliedFilters.action) {
          return false;
        }
      }

      // Filter by Period
      if (appliedFilters.period && appliedFilters.period !== "") {
        const itemPeriod = (item as any).period || (item as any).Period;
        if (
          itemPeriod === undefined ||
          String(itemPeriod) !== appliedFilters.period
        ) {
          return false;
        }
      }

      // Filter by Week
      if (appliedFilters.week && appliedFilters.week !== "") {
        const itemWeek = (item as any).week || (item as any).Week;
        if (
          itemWeek === undefined ||
          String(itemWeek) !== appliedFilters.week
        ) {
          return false;
        }
      }

      // If we get here, item passes all filters
      return true;
    });

    console.log("Final transformed data:", filteredData);
    return filteredData;
  }, [leadershipWalks, appliedFilters, zones]);
  // Effects
  useEffect(() => {
    const initializeData = async () => {
      // Fully reset both selected zone and leadership walk on component load
      resetSelectionsComplete();

      const locationText = (selectedLocation as any)?.displayText || (selectedLocation as any)?.name;
      if (locationText) {
        setLeadershipWalksLoading(true); // Use specific loading state for table data
        setLoading(true); // Keep for backward compatibility
        setError(null);
        try {
          await Promise.all([
            fetchZones({
              location: locationText,
              dispatch,
            }),
            fetchLeadershipWalks({
              location: locationText,
              dispatch,
            }),
          ]);
        } catch (error) {
          console.error("Error initializing data:", error);
          setError(
            error instanceof Error ? error.message : "Failed to fetch data"
          );
        } finally {
          setLeadershipWalksLoading(false); // Clear specific loading state
          setLoading(false); // Clear legacy loading state
        }
      }
    };

    initializeData();
  }, [selectedLocation, dispatch, resetSelectionsComplete]);

  // Remove filteredEmployees effect; always use transformedEmployees for tableData

  const closeDetailsModal = () => {
    setDetailsModalVisible(false);
    setSelectedRowData(null);
    // Reset only leadership walk when closing the details modal, preserve zone
    resetSelections();
  };

  // Show names in Created By and Finalized By dropdowns, but keep email for API
  const uniqueCreatedBy = useMemo(() => {
    // Get unique emails
    const creators = Array.from(
      new Set(
        leadershipWalks
          .map((item) => (item as any).Created_By || (item as any).createdBy)
          .filter(Boolean)
      )
    );
    // Map to { id: email, displayText: name, email }
    return creators.map((email) => ({
      id: email,
      displayText: formatUserName(email),
      email,
    }));
  }, [leadershipWalks]);

  const uniqueModifiedBy = useMemo(() => {
    const modifiers = Array.from(
      new Set(
        leadershipWalks
          .map((item) => (item as any).Modified_By || (item as any).modifiedBy)
          .filter(Boolean)
      )
    );
    return modifiers.map((email) => ({
      id: email,
      displayText: formatUserName(email),
      email,
    }));
  }, [leadershipWalks]);

  const uniqueActions = useMemo(() => {
    const actions = Array.from(
      new Set(
        leadershipWalks.map((item) => (item as any).status).filter(Boolean)
      )
    );
    return actions.map((status) => ({
      id: status,
      displayText: status,
    }));
  }, [leadershipWalks]);

  // Create period options (1-12)
  const periodOptions = Array.from({ length: 12 }, (_, i) => ({
    id: String(i + 1),
    displayText: String(i + 1),
  }));

  // Create week options (1-4)
  const weekOptions = Array.from({ length: 4 }, (_, i) => ({
    id: String(i + 1),
    displayText: String(i + 1),
  }));

  // Prepare filter options similar to SparcWalkScreen

  // Auto-apply filters effect (similar to SparcWalkScreen)
  useEffect(() => {
    const filtersChanged =
      JSON.stringify(filters) !== JSON.stringify(appliedFilters);
    if (filtersChanged) {
      const debounceTimer = setTimeout(() => {
        applyFilters();
      }, 250);

      return () => clearTimeout(debounceTimer);
    }
  }, [filters, appliedFilters, applyFilters]);

  // Place handleFilterChange here so it is in scope for filterOptions and LeadershipWalkMetrics
  const handleFilterChange = (
    filterType: keyof LeadershipWalkFilterState,
    value: DropdownItem | DropdownItem[] | null
  ) => {
    if (filterType === "zone" && value && !Array.isArray(value)) {
      setFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
    } else if (filterType === "frequency" && value && !Array.isArray(value)) {
      setFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
    } else if (
      ["createdBy", "modifiedBy", "action", "period", "week", "year"].includes(
        filterType
      ) &&
      value &&
      !Array.isArray(value)
    ) {
      // For createdBy/modifiedBy, use id (email) for filtering, not displayText
      if (filterType === "createdBy" || filterType === "modifiedBy") {
        setFilters((prev) => ({
          ...prev,
          [filterType]: value.id,
        }));
      } else {
        setFilters((prev) => ({
          ...prev,
          [filterType]: value.displayText,
        }));
      }
    } else if (value === null || (Array.isArray(value) && value.length === 0)) {
      setFilters((prev) => ({
        ...prev,
        [filterType]: null,
      }));
    }
  };

  const filterOptions = [
    {
      key: "zone",
      label: "Zone",
      selectedOptionId: filters.zone ? filters.zone.id : "",
      options: zones.map((zone) => ({
        id: zone.ZONE_ID.toString(),
        displayText: zone.ZONE,
      })),
    },
    {
      key: "frequency",
      label: "Frequency",
      selectedOptionId: filters.frequency ? filters.frequency.id : "",
      options: frequencyOptions,
    },
    {
      key: "createdBy",
      label: "Created By",
      selectedOptionId: filters.createdBy,
      options: uniqueCreatedBy.filter((opt) => opt.id !== ""),
    },
    {
      key: "modifiedBy",
      label: "Finalized By",
      selectedOptionId: filters.modifiedBy,
      options: uniqueModifiedBy.filter((opt) => opt.id !== ""),
    },
    {
      key: "action",
      label: "Status",
      selectedOptionId: filters.action,
      options: uniqueActions.filter((opt) => opt.id !== ""),
    },
    {
      key: "period",
      label: "Period",
      selectedOptionId: filters.period,
      options: periodOptions.filter((opt) => opt.id !== ""),
    },
    {
      key: "week",
      label: "Week",
      selectedOptionId: filters.week,
      options: weekOptions.filter((opt) => opt.id !== ""),
    },
    {
      key: "year",
      label: "Year",
      selectedOptionId: filters.year,
      options: getYearOptions(),
    },
  ];

  // If there's a success message, clear it after 5 seconds
  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        dispatch(setSuccessMessage(null));
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [successMessage, dispatch]);

  // Fetch zones_completed on load
  useEffect(() => {
    const fetchZonesCompleted = async () => {
      if (!selectedLocation?.displayText) {
        return;
      }
      // Use current period/week from Redux or fallback to 1

      const period = periodWeek?.data.period || "1"; // Default to 1 if not set
      const week = periodWeek?.data.week || "1"; // Default to 1 if not set
      try {
        const api = createApiClient();
        const clientTimestamp = getLocalTimestamp();
        const url = `/leadership-walks/zones_completed?location_name=${encodeURIComponent(
          selectedLocation.displayText
        )}&period=${period}&week=${week}&clientTimestamp=${encodeURIComponent(clientTimestamp)}`;
        const response = await apiClient(api, url, "GET");
        
        // Validate response
        if (!response || typeof response.totalZones !== 'number') {
          throw new Error("Invalid response format from zones_completed API");
        }
        
        setZonesCompleted({
          totalZones: response.totalZones,
          completedZoneIds: (response.completedZones || []).map(
            (z: any) => z.Zone_ID
          ),
        });
      } catch (error) {
        // Handle error with centralized error handler
        handleLeadershipWalkErrorWithFriendlyMessage(
          LEADERSHIP_WALK_API_NAMES.FETCH_ZONES_COMPLETED,
          error,
          true // Show modal overlay
        );
        setZonesCompleted({ totalZones: 0, completedZoneIds: [] });
      }
    };
    fetchZonesCompleted();
  }, [selectedLocation, filters.period, filters.week]);

  // Check if mobile filter overlay should be shown first
  if (isMobileFilterOverlayVisible) {
    return (
      <MobileFilterOverlay
        visible={isMobileFilterOverlayVisible}
        onDismiss={handleMobileFilterCancel}
        filters={filterOptions}
        onFilterChange={(key: string, value: any) => {
          switch (key) {
            case "zone":
              handleFilterChange("zone", value);
              break;
            case "frequency":
              handleFilterChange("frequency", value);
              break;
            case "createdBy":
              handleFilterChange("createdBy", value);
              break;
            case "modifiedBy":
              handleFilterChange("modifiedBy", value);
              break;
            case "action":
              handleFilterChange("action", value);
              break;
            case "period":
              handleFilterChange("period", value);
              break;
            case "week":
              handleFilterChange("week", value);
              break;
            case "year":
              handleFilterChange("year", value);
              break;
            default:
              console.log("Unknown filter key:", key);
          }
        }}
        onProceed={handleMobileFilterProceed}
        onCancel={handleMobileFilterCancel}
        currentFilters={filters}
      />
    );
  }

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === "ios" ? "padding" : undefined}
      style={[
        styles.keyboardView,
        { backgroundColor: colors.background.page },
      ]}
    >
      <ScrollView
        style={[
          styles.scrollView,
          { backgroundColor: colors.background.page },
        ]}
        contentContainerStyle={[
          styles.container,
          { backgroundColor: colors.background.page },
        ]}
        keyboardShouldPersistTaps="handled"
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            tintColor={isDarkMode ? colors.text.inverse : colors.brand.primary}
            colors={[isDarkMode ? colors.text.inverse : colors.brand.primary]}
            title="Refreshing..."
          />
        }
      >
        {successMessage && (
          <View
            style={[
              styles.successMessageContainer,
              isDarkMode && {
                backgroundColor: colors.background.surface,
                borderColor: colors.border.default,
              },
            ]}
          >
            <MaterialIcons
              name="check-circle"
              size={24}
              color={isDarkMode ? colors.text.inverse : "#008242"}
              style={styles.successIcon}
            />
            <Text
              style={[
                styles.successMessageText,
                isDarkMode && { color: colors.text.inverse },
              ]}
            >
              {successMessage}
            </Text>
          </View>
        )}

        <LeadershipWalkWelcome
          openFilterOverlay={handleBeginClick}
          clearWalk={() => {
            // Add clearWalk functionality here if needed
            console.log("Clearing walk data");
          }}
        />

        <WeeklyZonesCompleted
          totalZones={zonesCompleted.totalZones}
          completedZoneIds={zonesCompleted.completedZoneIds}
          isWeekOne={isWeekOne}
        />

        {/* Use the new LeadershipWalkMetrics component */}
        <LeadershipWalkMetrics
          filterOptions={filterOptions}
          handleFilterChange={(key, value) => {
            switch (key) {
              case "zone":
                handleFilterChange("zone", value);
                break;
              case "frequency":
                handleFilterChange("frequency", value);
                break;
              case "createdBy":
                handleFilterChange("createdBy", value);
                break;
              case "modifiedBy":
                handleFilterChange("modifiedBy", value);
                break;
              case "action":
                handleFilterChange("action", value);
                break;
              case "period":
                handleFilterChange("period", value);
                break;
              case "week":
                handleFilterChange("week", value);
                break;
              case "year":
                handleFilterChange("year", value);
                break;
              default:
                console.log("Unknown filter key:", key);
            }
          }}
          isLoading={leadershipWalksLoading}
          apiError={error}
          leadershipWalkData={leadershipWalks}
          tableColumns={leadershipWalkTableColumns.map((col) => {
            if (col.columnKey === "created" || col.columnKey === "modified") {
              return {
                ...col,
                formatter: (value: string) => formatDate(value),
              };
            }
            if (col.columnKey === "modifiedBy") {
              return {
                ...col,
                formatter: (value: string | null) => value || "-",
              };
            }
            return col;
          })}
          handleRowClick={handleRowClick}
          tableData={transformedEmployees}
          isMobile={isMobile}
          resetFilters={resetFilters}
          showMobileFilterButton={isIOSMobile()}
          onMobileFilterPress={handleMobileFilterPress}
        />

        {/* {loading && <LHLoader />} */}
        {renderFilterOverlay()}

        {/* Week 1 – No Leadership Walk Required modal */}
        <LHOverlay
          visible={showWeekOneModal}
          onDismiss={() => setShowWeekOneModal(false)}
          title="No Leadership Walk Required"
          description="No leadership walk is required this week. We recommend doing a site evaluation instead."
          size="small"
          close={true}
          hideFooter={true}
          bodyPadding={{ horizontal: 24 }}
        >
          <View style={weekOneModalStyles.buttonRow}>
            <TouchableOpacity
              style={[weekOneModalStyles.btn, weekOneModalStyles.primaryBtn]}
              onPress={() => {
                setShowWeekOneModal(false);
                // Delay opening the next modal so iOS has time to finish
                // dismissing the current one before presenting the next.
                setTimeout(() => setFilterOverlayVisible(true), 350);
              }}
            >
              <Text style={weekOneModalStyles.primaryBtnText}>Continue</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[weekOneModalStyles.btn, weekOneModalStyles.secondaryBtn]}
              onPress={() => { setShowWeekOneModal(false); if (onSiteEvaluationClick) { onSiteEvaluationClick(); } }}
            >
              <Text style={weekOneModalStyles.secondaryBtnText}>Site Evaluation</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[weekOneModalStyles.btn, weekOneModalStyles.tertiaryBtn]}
              onPress={() => setShowWeekOneModal(false)}
            >
              <Text style={weekOneModalStyles.tertiaryBtnText}>Cancel</Text>
            </TouchableOpacity>
          </View>
        </LHOverlay>

        <LeadershipWalkModal
          selectedRowData={selectedRowData}
          isOverlayVisible={isOverlayVisible}
          isLoading={detailsLoading} // Pass details loading state to modal
          closeOverlay={() => {
            setOverlayVisible(false);
            // Preserve zone but reset the selected walk when closing overlay
            resetSelections();
          }}
        />

        {currentView === VIEW_TYPES.DETAILS && selectedRowData && (
          <LeadershipWalkDetails
            isVisible={true}
            selectedWalk={selectedRowData}
            isLoading={detailsLoading} // Pass details loading state
            onBackPress={() => {
              // Reset only leadership walk, preserve zone
              resetSelections();
              setSelectedRowData(null);

              // Navigate back to welcome view
              setCurrentView(VIEW_TYPES.WELCOME);
            }}
          />
        )}
        
        {/* Error Modal */}
        <LeadershipWalkErrorModal />
      </ScrollView>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  keyboardView: {
    flex: 1,
  },
  container: {
    paddingVertical: "1.5%",
    paddingHorizontal: Platform.OS === "web" ? "1.5%" : 16,
    backgroundColor: "#F5F9FF",
    minHeight: "100%",
  },
  mobileContainer: {
    padding: 8,
  },
  scrollView: {
    flex: 1,
  },
  errorText: {
    color: "#DC3545",
    marginBottom: 16,
  },
  filterContainer: {
    padding: 16,
    gap: 16,
  },
  filterOverlayButton: {
    width: Platform.OS === "web" ? "15%" : "40%",
    fontSize: 16,
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 12,
    marginTop: 24,
  },
  tableSection: {
    marginTop: 24,
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    overflow: "hidden",
  },
  sectionHeader: {
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#E9ECEF",
  },
  tableTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: "#212529",
  },
  dataTableContainer: {
    ...Platform.select({
      ios: {
        shadowColor: "#0066CC",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 6,
      },
      android: {
        elevation: 8,
        shadowColor: "#0066CC",
      },
      web: {
        boxShadow: "0 4px 12px 0 rgba(0, 102, 204, 0.4)",
      },
    }),
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 16,
  },
  completedButton: {
    minWidth: Platform.OS === "web" ? 120 : undefined,
    maxWidth: Platform.OS === "web" ? 160 : undefined,
    flexGrow: 1,
    alignSelf: "center",
    paddingHorizontal: 12,
    backgroundColor: "#28A745",
    padding: 8,
    borderRadius: 4,
  },
  completedButtonText: {
    fontSize: 14,
    flexShrink: 1,
    textAlign: "center",
    color: "#FFFFFF",
    fontWeight: "500",
  },
  detailsContainer: {
    padding: 16,
    backgroundColor: "#FFFFFF",
  },
  detailsText: {
    fontSize: 16,
    marginBottom: 12,
    color: "#212529",
  },
  cardGridItem: {
    width: "48%",
    marginBottom: 16,
  },
  cardContainer: {
    padding: 16,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
  inspectionContainer: {
    flex: 1,
    paddingVertical: "1.5%",
    paddingLeft: 30,
    paddingRight: 30,
  },
  successMessageContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#d4edda",
    borderColor: "#c3e6cb",
    borderWidth: 1,
    borderRadius: 6,
    padding: 16,
    marginBottom: 16,
    width: "100%",
  },
  successIcon: {
    marginRight: 8,
  },
  successMessageText: {
    fontSize: 16,
    color: "#155724",
    flex: 1,
  },
});

const weekOneModalStyles = StyleSheet.create({
  buttonRow: {
    flexDirection: "row",
    justifyContent: "center",
    gap: 12,
    paddingVertical: 8,
  },
  btn: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 8,
    borderRadius: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  primaryBtn: {
    backgroundColor: "#0066CC",
  },
  primaryBtnText: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: "600",
  },
  secondaryBtn: {
    borderWidth: 1,
    borderColor: "#0066CC",
    backgroundColor: "transparent",
  },
  secondaryBtnText: {
    color: "#0066CC",
    fontSize: 16,
    fontWeight: "600",
  },
  tertiaryBtn: {
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: "#757575",
    borderRadius: 20,
  },
  tertiaryBtnText: {
    color: "#757575",
    fontSize: 16,
  },
});

export default LeaderShipWalkScreen;
